export interface IBrowseLinkApiResponse {
  city: string | null;
  insurance: string | null;
  provider_count: number;
  state: string;
  specialty: string | null;
  treatment_preference: string | null;
  url: string;
  psychiatrist: boolean;
}

export interface IBrowseLinkData {
  value: string;
  uriSafeValue: string;
}

export interface IBrowseLinkWithUrl extends IBrowseLinkData {
  url: string;
}

export interface IBrowseLinkSection {
  title: string;
  headingId: string;
  ariaLabelPrefix: string;
  items: IBrowseLinkWithUrl[];
}

export const BrowseLinkKeys = {
  CITY: 'city' as const,
  INSURANCE: 'insurance' as const,
  MODALITY: 'modality' as const,
  PSYCHIATRIST: 'psychiatrist' as const,
  SPECIALTY: 'specialty' as const,
  TREATMENT_PREFERENCE: 'treatment_preference' as const
};

export type BrowseLinkKeyType = typeof BrowseLinkKeys[keyof typeof BrowseLinkKeys];
